<div class="box-up">
    <div class="container">
        <div *ngIf="!isMobile" class="box-up-in">
            <div class="left-section">
                <div class="this-warp">
                    <div [ngStyle]="clientConfig?.style.color" class="value-text" style="min-width: 135px;"> <i
                            class="fa fa-map-marker" aria-hidden="true"></i> {{outlet?.name}}</div>
                </div>
            </div>

            <div class="left-section" *ngIf="outlet?.deliveryType === deliveryType.Delivery">
                <div class="this-warp">
                    <div class="icon-text">Minimum Order Amount
                    </div>
                    <div [ngStyle]="clientConfig?.style.color" class="value-text" style="min-width: 135px;">
                        {{clientConfig?.currency}} {{outlet?.minAmount | number : '1.2-2'}}</div>
                </div>
            </div>

            <div class="left-section == hideon-mbile-ag">
                <div class="this-warp">
                    <div class="icon-text">{{outlet?.deliveryType === deliveryType.Delivery ? 'Delivery' :
                        'Pickup'}} Time <i class="fa fa-clock-o" [ngStyle]="clientConfig?.style.color"
                            aria-hidden="true"></i></div>
                    <div [ngStyle]="clientConfig?.style.color" class="value-text"><span
                            style="min-width:17px; display:inline-block;">{{outlet?.time}}</span></div>
                </div>
                <div class="start-link-warp">
                    <button type="button" (click)="startOver()" [ngStyle]="clientConfig?.style.bg">Start
                        Over</button>
                </div>
            </div>
        </div>
        <div *ngIf="isMobile" class="box-up-in">
            <div class="left-section">
                <div class="this-warp">
                    <div [ngStyle]="clientConfig?.style.color" class="value-text" style="min-width: 135px;">
                        {{outlet?.name}}</div>
                </div>
            </div>
            <div class="left-section colum-type">
                <div class="this-warp" *ngIf="outlet?.deliveryType === deliveryType.Delivery">
                    <div class="icon-text">Minimum:&nbsp;</div>
                    <div [ngStyle]="clientConfig?.style.color" class="value-text" style="min-width: 135px;">
                        {{clientConfig?.currency}} {{outlet?.minAmount | number : '1.2-2'}}</div>
                </div>
                <div class="this-warp">
                    <div class="icon-text">{{outlet?.deliveryType === deliveryType.Delivery ? 'Delivery' :
                        'Pickup'}}:&nbsp;<span [ngStyle]="clientConfig?.style.color"
                            class="value-text">{{outlet?.time}}</span></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="start-link-warp d-block d-sm-none sover-btn">
    <button type="button" (click)="startOver()">Start Over</button>
</div>